import { formatCoordinate, formatCoordinateValue, type GeoCoordinate } from '../domain/coordinates';
import { icon } from './icons';

export type LocationCardAction = 'copy' | 'zoom' | 'clear';

/**
 * "Ubicación" card shown at the top of the Properties pane while a marker is active.
 * It lives in its own container, so the agricultural Properties underneath are never replaced or altered.
 */
export class LocationCard {
  constructor(private readonly element: HTMLElement, private readonly onAction: (action: LocationCardAction) => void, private readonly elevation: ((location: GeoCoordinate) => string) | null = null) {
    element.addEventListener('click', (event) => {
      const button = (event.target as Element).closest<HTMLButtonElement>('[data-location-action]');
      if (button) this.onAction(button.dataset.locationAction as LocationCardAction);
    });
  }

  render(location: GeoCoordinate | null): void {
    this.element.hidden = !location;
    if (!location) { this.element.innerHTML = ''; return; }
    const row = (label: string, value: string, stacked = false): string => `<div class="property-row${stacked ? ' stacked' : ''}"><dt>${label}</dt><dd>${value}</dd></div>`;
    this.element.innerHTML = `
      <div class="entity-header"><span class="entity-kind">${icon('point')}Ubicación</span><h3>Punto marcado</h3></div>
      <dl class="property-list">${row('Latitud', formatCoordinateValue(location.lat))}${row('Longitud', formatCoordinateValue(location.lon))}${row('Coordenada WGS84', formatCoordinate(location), true)}${this.elevation ? row('Cota DEM · GLO‑30', this.elevation(location)) : ''}</dl>
      <div class="entity-actions">
        <button type="button" class="button" data-location-action="copy">${icon('copy')}Copiar coordenada</button>
        <button type="button" class="button" data-location-action="zoom">${icon('zoomIn')}Zoom</button>
        <button type="button" class="button" data-location-action="clear">${icon('close')}Quitar marcador</button>
      </div>`;
  }
}
